'use strict';

// export this package's api
module.exports = require('./Upload');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.3.3@rc-upload/lib/index.js
 ** module id = 449
 ** module chunks = 0 1
 **/